import React from 'react';
import { Users, Target, Zap } from 'lucide-react';

const About = ({ language }) => {
  const companyInfo = {
    ko: {
      title: "AI-LABC 소개",
      subtitle: "혁신적인 AI 솔루션으로 미래를 만들어갑니다",
  description: "AI-LABC는 최신 인공지능 기술을 활용하여 다양한 산업 분야의 문제를 해결하는 전문 기업입니다. 우리는 고객의 비즈니스 성장과 디지털 혁신을 위해 끊임없이 연구하고 개발하고 있습니다.",
      mission: "최첨단 AI 기술을 통해 고객의 비즈니스 가치를 극대화하고, 사회에 긍정적인 영향을 미치는 혁신적인 솔루션을 제공합니다.",
      vision: "AI 기술의 민주화를 통해 모든 기업이 혁신적인 디지털 전환을 경험할 수 있는 세상을 만듭니다.",
      founded: "2020년 설립",
      employees: "50+ 전문가",
      projects: "100+ 프로젝트",
      clients: "200+ 고객사"
    },
    en: {
      title: "About AI-LABC",
      subtitle: "Creating the future with innovative AI solutions",
  description: "AI-LABC is a specialized company that solves problems across various industries using cutting-edge artificial intelligence technology. We continuously research and develop to drive customer business growth and digital innovation.",
      mission: "We maximize customer business value through state-of-the-art AI technology and provide innovative solutions that create positive social impact.",
      vision: "We create a world where all companies can experience innovative digital transformation through the democratization of AI technology.",
      founded: "Founded in 2020",
      employees: "50+ Experts",
      projects: "100+ Projects",
      clients: "200+ Clients"
    }
  };

  const info = companyInfo[language];

  const stats = [
    { icon: <Users size={24} />, label: language === 'ko' ? '전문가' : 'Experts', value: '50+' },
    { icon: <Target size={24} />, label: language === 'ko' ? '프로젝트' : 'Projects', value: '100+' },
    { icon: <Zap size={24} />, label: language === 'ko' ? '고객사' : 'Clients', value: '200+' }
  ];

  const services = [
    {
      title: language === 'ko' ? 'AI 솔루션 개발' : 'AI Solution Development',
      description: language === 'ko' 
        ? '머신러닝, 딥러닝, 자연어 처리 등 최신 AI 기술을 활용한 맞춤형 솔루션을 개발합니다.'
        : 'Develop customized solutions using cutting-edge AI technologies including machine learning, deep learning, and natural language processing.'
    },
    {
      title: language === 'ko' ? '데이터 분석 및 인사이트' : 'Data Analysis & Insights',
      description: language === 'ko'
        ? '대용량 데이터를 분석하여 비즈니스에 가치 있는 인사이트를 도출합니다.'
        : 'Analyze large-scale data to derive valuable business insights.'
    },
    {
      title: language === 'ko' ? 'AI 컨설팅' : 'AI Consulting',
      description: language === 'ko'
        ? 'AI 도입 전략 수립부터 구현까지 전 과정을 지원하는 전문 컨설팅을 제공합니다.'
        : 'Provide specialized consulting supporting the entire process from AI adoption strategy to implementation.'
    },
    {
      title: language === 'ko' ? '클라우드 AI 서비스' : 'Cloud AI Services',
      description: language === 'ko'
        ? 'AWS, Azure, GCP 등 주요 클라우드 플랫폼에서 AI 서비스를 구축하고 운영합니다.'
        : 'Build and operate AI services on major cloud platforms including AWS, Azure, and GCP.'
    }
  ];

  return (
    <div className="page-container">
      <div className="container">
        {/* 헤더 섹션 */}
        <div className="page-header">
          <h1 className="page-title">{info.title}</h1>
          <p className="page-subtitle">{info.subtitle}</p>
        </div>

        {/* 회사 소개 */}
        <div className="page-content">
          <div className="page-description">
            <p>{info.description}</p>
          </div>

          {/* 통계 */}
          <div className="section">
            <div className="grid grid-3">
              {stats.map((stat, index) => (
                <div key={index} className="card stat-card">
                  <div className="icon">{stat.icon}</div>
                  <div className="stat-value">{stat.value}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* 미션 & 비전 */}
          <div className="section">
            <div className="card">
              <h2 style={{ fontSize: '1.5rem', fontWeight: 600, marginBottom: '1rem', color: 'inherit' }}>
                {language === 'ko' ? '미션 & 비전' : 'Mission & Vision'}
              </h2>
              <p style={{ lineHeight: '1.7', color: 'inherit' }}>
                {info.mission} {info.vision}
              </p>
            </div>
          </div>

          {/* 서비스 */}
          <div className="section" style={{ marginTop: '3rem' }}>
            <h2 className="section-title">{language === 'ko' ? '주요 서비스' : 'Our Services'}</h2>
            <div className="grid grid-2">
              {services.map((service, index) => (
                <div key={index} className="card">
                  <h3 style={{ fontSize: '1.3rem', fontWeight: 600, marginBottom: '1rem', color: 'inherit' }}>
                    {service.title}
                  </h3>
                  <p style={{ lineHeight: '1.6', color: 'inherit' }}>{service.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
